module.exports = __webpack_public_path__ + "static/media/CSPORT PHONO AMPLIFIER C3EQM2.5307608c.png";